import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { AuthEntryCard } from "@/features/auth/components/AuthEntryCard";
import { Button } from "@/shared/components/ui/Button";
import { LoginArrowIcon } from "@/shared/components/ui/icons/LoginArrowIcon";
import { UserIcon } from "@/shared/components/ui/icons/UserIcon";
import { BrandWordmark } from "@/shared/components/branding/BrandWordmark";

import { LanguageSelector } from "@/shared/components/ui/LanguageSelector";

function LanguageSwitcher() {
  const { i18n, t } = useTranslation("common");

  const options = [
    { label: t("language.es"), value: "es" },
    { label: t("language.en"), value: "en" },
  ];

  return (
    <LanguageSelector
      onChange={(lang) => void i18n.changeLanguage(lang)}
      options={options}
      value={i18n.language}
    />
  );
}

export function AuthEntryPage() {
  const navigate = useNavigate();
  const { t } = useTranslation(["common", "auth"]);

  return (
    <AuthEntryCard
      contentClassName="flex-1 justify-center gap-12"
      hideLogo
      variant="entry"
    >
      <BrandWordmark />
      <div
        className="flex w-full max-w-88 flex-col gap-4"
        data-node-id="5018:27442"
      >
        <Button
          className="min-h-9 px-5 py-1.5 text-sm"
          iconLeft={<LoginArrowIcon />}
          onClick={() => navigate("/login")}
        >
          {t("common:btn.login")}
        </Button>
        <Button
          className="min-h-9 px-5 py-1.5 text-sm"
          iconLeft={<UserIcon />}
          onClick={() => navigate("/register/consent")}
          variant="secondary"
        >
          {t("common:btn.register")}
        </Button>
      </div>
      <LanguageSwitcher />
    </AuthEntryCard>
  );
}
